import IcArrowRightSmall from '@/assets/svg/ic-arrow-right-small.svg?inline'

export default {
  name: 'ItemiManufacture',
  components: {
    IcArrowRightSmall
  },
  props: {
    item: {
      /**
       * Пример
       * {
          "id": 12,
          "title": "Гастелло",
          "city_id": 2,
          "coordinates": {
          "lat": "59.857884",
          "lng": "30.332649"
          },
          "current_admin": {
            "admin_id": 1,
            "first_name": "Валентин",
            "last_name": "Гусев"
          }
        }
       */
      type: Object,
      required: true
    },
    inForm: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isHovered: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clickInForm() {
      if (!this.disabled) {
        this.$emit('select-item', this.item)
      }
    },
    clickNotInForm() {
      this.$emit('select-item', this.item)
    }
  }
}